export function goToLogin() {
  if (
    import.meta.env.VITE_TARGET_ENV &&
    !['production'].includes(import.meta.env.VITE_TARGET_ENV)
  ) {
    const loginPath = `${window.env.PATH_PREFIX}/login`;
    if (window.location.pathname === loginPath) {
      return;
    }
    window.location.href = loginPath;
    return;
  }
  window.open(`${window.location.origin}/login`, '_self');
}
